// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___r66oE","flex":"flex___1bH7G","label":"label___3crMR","full":"full___AiUJf","title":"title___1F3Ri","subtitle":"subtitle___39yLo"};